module.exports = __webpack_public_path__ + "assets/img/2d954503df9545f0db9ae9ed025c5eee.png";